(() => {
  'use strict';
  if (window.__dermaArrowCleanupLoaded) return;
  window.__dermaArrowCleanupLoaded = true;
  const arrow = /[\u2190-\u21FF\u27F0-\u27FF\u2900-\u297F\u2B00-\u2B11\u2794\u279C\u27A1\u276E\u276F\u2039\u203A]/g;
  const hasArrow = /[\u2190-\u21FF\u27F0-\u27FF\u2900-\u297F\u2B00-\u2B11\u2794\u279C\u27A1\u276E\u276F\u2039\u203A]/;
  const skip = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'CODE', 'PRE']);
  const pending = [];
  const queued = new WeakSet();
  const styled = new WeakSet();
  let scheduled = false;

  function excluded(node) {
    const parent = node.nodeType === 1 ? node : node.parentElement;
    return !parent || skip.has(parent.tagName) || !!parent.closest('script,style,noscript,textarea,code,pre');
  }

  function clean(node) {
    if (!node.isConnected || excluded(node)) return;
    if (node.nodeType === 3) {
      if (hasArrow.test(node.nodeValue || '')) node.nodeValue = node.nodeValue.replace(arrow, '').replace(/\uFE0F/g, '');
      return;
    }
    if (node.nodeType !== 1 || styled.has(node)) return;
    styled.add(node);
    if (hasArrow.test(getComputedStyle(node, '::before').content || '')) node.classList.add('dt-no-arrow-before');
    if (hasArrow.test(getComputedStyle(node, '::after').content || '')) node.classList.add('dt-no-arrow-after');
  }

  function schedule() {
    if (scheduled || !pending.length) return;
    scheduled = true;
    if ('requestIdleCallback' in window) window.requestIdleCallback(flush, { timeout: 500 });
    else window.setTimeout(flush, 16);
  }

  function flush() {
    scheduled = false;
    const started = performance.now();
    let steps = 0;
    while (pending.length && steps < 24 && (steps === 0 || performance.now() - started < 6)) {
      const task = pending[0];
      if (!task.root.isConnected) {
        pending.shift();
        queued.delete(task.root);
        steps++;
        continue;
      }
      const node = task.started ? task.walker.nextNode() : task.root;
      task.started = true;
      if (!node) {
        pending.shift();
        queued.delete(task.root);
      } else clean(node);
      steps++;
    }
    schedule();
  }

  function enqueue(root) {
    if (!root || !root.isConnected || queued.has(root) || excluded(root)) return;
    if (root.nodeType === 3 && !hasArrow.test(root.nodeValue || '')) return;
    if (root.nodeType !== 1 && root.nodeType !== 3) return;
    queued.add(root);
    pending.push({ root, started: false, walker: document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode: node => excluded(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    }) });
    schedule();
  }

  function start() {
    if (!document.body) return;
    enqueue(document.body);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') enqueue(record.target);
        else for (const node of record.addedNodes) enqueue(node);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
